import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import './Auth.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(true);
            } else {
                setError(data.error || 'Error en la solicitud');
            }
        } catch (err) {
            setError('Error de conexión. Comprueba tu internet e inténtalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container auth-page">
            <Navbar />
            <div className="auth-card glass">
                <div className="auth-header">
                    <h2>¿Has olvidado tu contraseña?</h2>
                    <p>Introduce tu correo electrónico para recibir un enlace de recuperación.</p>
                </div>

                {error && <div className="error-message">{error}</div>}

                {success ? (
                    <div className="success-container">
                        <div className="success-message">
                            Si la cuenta existe, hemos enviado un enlace de restablecimiento a tu correo.
                        </div>

                        <div className="auth-footer" style={{ marginTop: '20px' }}>
                            <p><Link to="/login">Volver al inicio de sesión</Link></p>
                        </div>
                    </div>
                ) : (
                    <>
                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="form-group">
                                <label>Correo electrónico</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Ej: usuario@ejemplo.com"
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn-primary btn-block"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner"></span>
                                        Enviando...
                                    </>
                                ) : 'Enviar enlace'}
                            </button>
                        </form>

                        <div className="auth-footer">
                            <p>¿Recordaste tu contraseña? <Link to="/login">Iniciar sesión</Link></p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;
